import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IndustryService } from '../../services/industry.service';

/** Blocks /cash-denomination for industries where denomination is turned off (feature-flags.ts). */
export const denominationGuard: CanActivateFn = () => {
  return inject(IndustryService).isDenominationEnabled()
    ? true
    : inject(Router).parseUrl('/dashboard');
};
